import React from 'react';

import styles from './loader.styles';

const Loader: React.FC<{ position?: string }> = props => (
    <div className={'flex justify-center items-center w-full h-full z-10 ' + props.position}>
        <style jsx>{styles}</style>
        <div className="Loading"></div>
    </div>
);

Loader.defaultProps = {
    position: 'absolute',
};

export default Loader;
